import React from 'react';
import ModuloTemplate from '../Elements/ModuloTemplate';

const bnrimg = require('../../images/pic2.jpg');
const productImg = require('../../images/Finanzas.png');

const FinzanceModule = () => (
    <ModuloTemplate
        moduleKey="finanzas"
        bnrimg={bnrimg}
        productImg={productImg}
    />
);

export default FinzanceModule;
